<div class="layout-sidebar cb-sidebar-new" [class.rail]="collapsed()">
    <!-- Static site context. data-site-switcher marks the future dropdown hook. -->
    @if (!collapsed()) {
        <div class="site-context" data-site-switcher>
            <div class="site-context-label">Site</div>
            <div class="site-context-name">{{ siteName() }}</div>
        </div>
    } @else {
        <!-- Rail: same box and height as the site context, showing the site's initials. -->
        <div class="site-context site-context-mini" data-site-switcher [pTooltip]="'Site: ' + siteName()" tooltipPosition="right">{{ siteInitials() }}</div>
    }

    <div class="layout-menu-container h-full">
        <ul class="layout-menu">
            @for (group of groups; track group.key) {
                @let groupItems = itemsByGroup().get(group.key) ?? [];
                @if (groupItems.length > 0) {
                <li class="layout-root-menuitem">
                    @if (group.label) {
                        <div class="layout-menuitem-root-text text-secondary">
                            <span>{{ group.label }}</span>
                        </div>
                    }
                    <ul>
                        @for (item of groupItems; track item.routerLink) {
                            <li>
                                <a [routerLink]="item.routerLink" routerLinkActive="active-route" [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }" pRipple [pTooltip]="collapsed() ? item.label : ''" tooltipPosition="right">
                                    <i class="layout-menuitem-icon" [ngClass]="item.icon"></i>
                                    <span class="layout-menuitem-text">{{ item.label }}</span>
                                    @if (badgeFor(item) !== undefined && badgeFor(item) !== null) {
                                        <span class="ml-auto">
                                            <p-badge [value]="badgeFor(item)"></p-badge>
                                        </span>
                                    }
                                </a>
                            </li>
                        }
                    </ul>
                </li>
                }
            }
            @if (showAdmin()) {
                <!-- Administration is a group header with no children: the header itself opens the /admin hub.
                     Headers are hidden in the icon rail, so the rail shows a cog item instead. -->
                <li class="layout-root-menuitem">
                    @if (!collapsed()) {
                        <a routerLink="/admin" class="layout-menuitem-root-text text-secondary admin-header" [class.active]="adminActive()">
                            <span>Administration</span>
                            <i class="pi pi-angle-right"></i>
                        </a>
                    } @else {
                        <ul>
                            <li>
                                <a routerLink="/admin" [class.active-route]="adminActive()" pRipple pTooltip="Administration" tooltipPosition="right">
                                    <i class="layout-menuitem-icon pi pi-cog"></i>
                                </a>
                            </li>
                        </ul>
                    }
                </li>
            }
        </ul>
    </div>
</div>
